import { FacilityState, RoomFacilityState, ExtraFacilityState } from './../../models/search';
import { Actions, ActionTypes } from './actions';
import { facilityAdapter, initialFacilityState, initialRoomFacilityState, initialExtraFacilityState } from './state';


/*export function facilitiesReducer(state = initialState, action: Actions): FacilityState {
  switch (action.type) {
    case ActionTypes.ADD_FACILITY: {
      return facilityAdapter.addMany( action.payload.facilities, state);
    }
    default: {
      return state;
    }
  }
}*/



export function FacilitiesReducer(state = initialFacilityState, action: Actions): FacilityState {
  switch (action.type) {
    case ActionTypes.ADD_FACILITY: {
      return facilityAdapter.addAll( action.payload.facilities, state);
    }
    default: {
      return state;
    }
  }
}

export function roomFacilitiesReducer(state = initialRoomFacilityState, action: Actions): RoomFacilityState {
  switch (action.type) {
    case ActionTypes.ADD_ROOM_FACILITY: {
      return facilityAdapter.addAll( action.payload.facilities, state);
    }
    default: {
      return state;
    }
  }
}

export function extraFacilitiesReducer(state = initialExtraFacilityState, action: Actions): ExtraFacilityState {
  switch (action.type) {
    case ActionTypes.ADD_EXTRA_FACILITIES: {
      return facilityAdapter.addOne( action.payload.facilities, state);
    }
    default: {
      return state;
    }
  }
}
